import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Swallow the next `click` (capture phase) so an "outside press" that dismisses
 * a popover/menu ONLY closes it — the element under the cursor never receives
 * the click (e.g. clicking a timeline item just closes the open menu instead of
 * opening that item). Call right after closing on an outside pointerdown.
 *
 * Self-cleans when the click fires, or after a short timeout if none follows
 * (e.g. the press began a drag).
 */
export function swallowNextClick() {
  if (typeof window === 'undefined') return;
  const opts = { capture: true } as const;
  const swallow = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    cleanup();
  };
  const cleanup = () => {
    window.removeEventListener('click', swallow, opts);
    window.clearTimeout(timer);
  };
  const timer = window.setTimeout(cleanup, 400);
  window.addEventListener('click', swallow, opts);
}
